import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
    aboutLostContainer: {
        marginTop: '45px',
        [theme.breakpoints.up('md')]: {
            display: 'flex',
            justifyContent: 'space-between'
        }
    },
    aboutLostCompanyContainer: {
        marginTop: 20
    },
    recommendationBox: {
        marginTop: 20
    },
    aboutLostContent: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        marginBottom: '40px',
        paddingRight: '20px',
        [theme.breakpoints.down('sm')]: {
            zIndex: '2',
            alignItems: 'center'
        }
    },
    title: {
        color: 'var(--foreground-black)',
        fontSize: 100,
        textTransform: 'uppercase',
        [theme.breakpoints.down('sm')]: {
            marginBottom: '24px',
            fontSize: 80
        }
    },
    subtitle: {
        fontSize: 40
    },
    subsubtitle: {
        fontSize: 24
    },
    redirectLink: {
        '&:hover': {
            color: 'var(--foreground-purple) !important'
        }
    },
    aboutLostImg: {
        display: 'flex',
        alignItems: 'flex-end',
        '& img': {
            height: 300,
            transform: 'scale(1.4)',
            [theme.breakpoints.down('sm')]: {
                height: 280,
                margin: '0 auto'
            }
        }
    },
    lostInfoContainer: {
        '& h2': {
            [theme.breakpoints.up('md')]: {
                fontSize: 30
            }
        },
        '& h3': {
            marginBottom: 8
        }
    },
    links: {
        display: 'flex',
        flexDirection: 'column',
        gap: 6
    },
    mainContainer: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: '50px'
    },
    bannerText: {
        margin: '50px 0px',
        textAlign: 'center'
    },
    similarJobs: {
        width: '100%'
    },
    similarJobsBox: {
        paddingTop: 60,
        paddingBottom: 24,
    },
    similarArticlesBox: {
        paddingTop: 50,
        paddingBottom: 80,
    },
    schoolCardBox: {
        marginRight: 16
    },
    schoolButtonContainer: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: 50
    }
}))
